import {type ChangeEventHandler, type JSX, useCallback, useRef} from 'react';
import {useSelector, useStore} from 'react-redux';
import {
  selectEditTitle,
  selectTitleError,
} from '~/CreateFabricInvitation/reducers/details/selectors';
import {scrollEventTitleModuleIntoView} from '~/CreateFabricInvitation/utils/misc';
import {useFormValidations} from '~/common/FabricInvitation/hooks/useFormValidations';
import {validateTitle} from '~/common/FabricInvitation/utils/validation';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {Input} from '~library/atoms/Input';

export const Title = (): JSX.Element => {
  const store = useStore();
  const ref = useRef<HTMLInputElement>(null);
  const title: string = useSelector(selectEditTitle);
  const error: boolean = useSelector(selectTitleError);

  const handleChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      store.dispatch({
        type: UPDATE_EVENT_DETAILS,
        payload: {title: e.target.value},
      });
      scrollEventTitleModuleIntoView();
    },
    [store]
  );

  const validate = useCallback(() => {
    return validateTitle(title, ref.current);
  }, [title]);

  useFormValidations('title', validate);

  return (
    <div className="create-flow__form-section event-details__title">
      <Input
        label="Event Title"
        id="title"
        name="title"
        data-qa-id="event-title"
        error={error && 'Event title is required'}
        type="text"
        value={title}
        onFocus={scrollEventTitleModuleIntoView}
        onChange={handleChange}
        placeholder="Your event title"
        required
        maxLength={50}
        className="create-flow__form__input"
        ref={ref}
      />
    </div>
  );
};
